import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft, ShieldAlert } from "lucide-react";
import { MEN_TOOLS } from "@/data/learn/men-tools";
import { MenCrisisNote } from "@/components/men/MenExercises";

const TITLE = "Practical Grounding Tools for Men — Recovery Trauma™";
const DESC = "Tool Shop grounding, cool water grounding and the wall push: simple ways to reconnect with your body and release tension.";

export const Route = createFileRoute("/learn/men-and-trauma/tools")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: ToolsPage,
});

function ToolsPage() {
  return (
    <main className="mx-auto max-w-3xl px-4 pb-16 pt-6 sm:pt-10">
      <Link to="/learn/men-and-trauma" className="inline-flex min-h-[44px] items-center gap-1 text-sm text-primary">
        <ArrowLeft className="h-4 w-4" /> Men & Trauma
      </Link>
      <h1 className="mt-2 font-serif text-3xl text-foreground">Practical Tools</h1>
      <p className="mt-2 text-foreground/80">Simple ways to reconnect with your body, release tension and bring your attention back to the present. Stop any exercise at any time.</p>
      <div className="mt-6 space-y-6">
        {MEN_TOOLS.map((t) => (
          <article key={t.id} id={t.id} className="scroll-mt-24 overflow-hidden rounded-3xl border border-border bg-card">
            <img src={t.image} alt={t.alt} loading="lazy" width={1024} height={768} className="aspect-[16/9] w-full object-cover" />
            <div className="p-5">
              <h2 className="font-serif text-2xl text-foreground">{t.emoji} {t.title}</h2>
              <p className="mt-1 text-primary">{t.tagline}</p>
              <p className="mt-3 text-foreground/90">{t.intro}</p>
              <ul className="mt-2 space-y-1.5">
                {t.steps.map((s) => (
                  <li key={s} className="relative ps-5 text-foreground/90 before:absolute before:start-0 before:text-primary before:content-['•']">{s}</li>
                ))}
              </ul>
              <p className="mt-3 text-foreground/90">{t.closing}</p>
              {t.id === "tool-shop" && (
                <Link
                  to="/learn/men-and-trauma/tools/tool-shop"
                  className="mt-4 inline-flex h-11 items-center gap-2 rounded-full bg-[var(--gradient-gold)] px-5 text-[14px] font-semibold text-foreground shadow-sm transition hover:opacity-90"
                >
                  Start The Tool Shop →
                </Link>
              )}
              <p className="mt-4 flex gap-2 rounded-xl bg-muted/60 p-3 text-sm text-muted-foreground">
                <ShieldAlert className="mt-0.5 h-4 w-4 shrink-0 text-primary" /> {t.safety}
              </p>
            </div>
          </article>
        ))}
      </div>
      <MenCrisisNote />
    </main>
  );
}
